<template>
  <div class="ttn-responses">
    <el-divider />
    <el-table
      v-if="loading || !ttnResponses.length"
      v-loading="loading"
      :data="ttnResponses"
      element-loading-text="Загрузка..."
    >
      <p slot="empty">Ничего не найдено</p>
    </el-table>
    <unknown-or-copy v-if="!loading && !ttnResponses.length" :middle="true" />
    <el-collapse-transition v-if="ttnResponses.length && !loading">
      <section>
        <ttn-response
          v-for="item in ttnResponses"
          :key="item.response_id"
          :item="item"
          @click.native="$emit('set', item)"
        />
      </section>
    </el-collapse-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TtnResponse from './TtnResponse'
import UnknownOrCopy from '../UnknownOrCopy'

export default {
  name: 'TtnResponses',
  components: { UnknownOrCopy, TtnResponse },
  computed: {
    ...mapGetters('hardware', ['ttnResponses', 'getLoading']),
    loading() {
      return this.getLoading('Responses')
    },
  },
}
</script>

<style lang="sass">
.ttn-responses
  height: calc(100vh - 412px)
  overflow-y: auto
  padding: 0 10px
  .el-table::before
    display: none
</style>
